import { connect } from 'react-redux';
import React, { useEffect, useState } from "react";
import StateMape from "../../store/stateMap";
import { useFormik } from 'formik';
import "../../sass/form/form.scss";
import api from '../../api';
import { popinfo } from "../../component/Fancybox/Fancybox";
import _ from "lodash";

const EditResearch = (props) => {
    

    const [initiative, setInitiative] = useState(props.sentInitiative);

    const [formDataLoad, setFormDataLoad] = useState(true);

    const [socioGoals, setSocioGoals]           = useState(false);
    const [knowledgeField, setKnowledgeField]   = useState(false);
    const [researchField, setResearchField]     = useState(false);


    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {

            if(value === null)
            {
                value = '';
            }

            formik.setFieldValue(attribute, value);

        });
    }

    const formik = useFormik({
        initialValues: {
            InitiativeID    : initiative.InitiativeID
            ,ResearchType   : ''
            ,FundingInst    : ''
            ,FundingSource  : ''
            ,Funding        : ''
        }
        ,onSubmit: values => {
            

            var SavingLoader = popinfo('loader', 'Saving Research Information', 'Detailed research information help crowd <br/> has better understanding of your initiative');

            api('/InitiativeResearch', 'post', _.assignIn({}, values, {
                
            }), 'Bearer ' + props.auth.token)
                .then(function(response){
                    
                    SavingLoader.close();
                    
                    settingFormValues(response.initiative[0]);

                    props.onSave(response.initiative[0]);
                        
                })
                .catch((error) => {
                    popinfo('error', 'Saving Research Information', error, {}, SavingLoader);
                });
        }
    });

    useEffect(() => {

        if(initiative.InitiativeID !== props.sentInitiative.InitiativeID)
        {
            setInitiative(props.sentInitiative);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.sentInitiative])

    useEffect(()=>{

        if(props.auth.user && initiative.InitiativeID > 0)
        {
            setFormDataLoad(true);

            Promise.all([
                api('/SocioGoals')
                ,api('/KnowledgeField')
                ,api('/ResearchField')
            ]).then(response => {
                setSocioGoals(response[0].goals);
                setKnowledgeField(response[1].field);
                setResearchField(response[2].field);
                settingFormValues(initiative);
                setFormDataLoad(false);
            })


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.sentInitiative]);

    return (
        <form className="generic-form"  onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <label htmlFor="" className="label">Research Length*</label>
                <div className="description">Your research planned time (in Years)</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.ResearchLength}
                        name="ResearchLength"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Research Output*</label>
                <div className="description">Results generated by your research</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.TargetProduct} name="TargetProduct" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Defined Your Research Output</option>
                            {
                                props.config.ResearchOutput.map((output) => (
                                    <option value={output[0]} key={output[0]}>{output[1]}</option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Research Type*</label>
                <div className="description">Classification of your research</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.ResearchType} name="ResearchType" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Choose your research type</option>
                            {
                                props.config.ResearchType.map((rType) => (
                                    <option value={rType[0]} key={rType[0]}>{rType[1]}</option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Field of Science By QS Subject*</label>
                <div className="description">Your research field of science</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.KnowledgeFieldID} name="KnowledgeFieldID" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Defined Your Research Science Field</option>
                            {
                                knowledgeField !== false && knowledgeField.map(field => (
                                    <option value={field.KnowledgeFieldID} key={field.KnowledgeFieldID} dangerouslySetInnerHTML={{__html : field.FieldName }}></option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Research Field*</label>
                <div className="description">Your research field</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.ResearchFieldID} name="ResearchFieldID" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Defined Your Research Field</option>
                            {
                                researchField !== false && researchField.map(field => (
                                    <option value={field.ResearchFieldID} key={field.ResearchFieldID} dangerouslySetInnerHTML={{__html : field.FieldName }}></option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Socio-Economic Goals*</label>
                <div className="description">Impact of your research</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.SocioImpactID} name="SocioImpactID" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Choose the impact of Research</option>
                            {
                                socioGoals !== false && socioGoals.map(goal => (
                                    <option value={goal.SocioImpactID} key={goal.SocioImpactID} dangerouslySetInnerHTML={{__html : goal.ImpactName }}></option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Expected Funding</label>
                <div className="description">Tell crowd your research expected funding</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <input type="number" className="form-control text" 
                        onChange={(e) => {
                            e.preventDefault();

                            if(e.currentTarget.value === '')
                            {
                                formik.setFieldValue('FundingSource', '');

                                formik.setFieldValue('FundingInst', '');
                            }

                            formik.handleChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.Funding}
                        name="Funding"
                    />
                }
            </div>
            {
                formik.values.Funding > 0 && 
                <div className="form-group">
                    <label htmlFor="" className="label">Funding Source</label>
                    <div className="description">Type this research source of funding</div>
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <input type="text" className="form-control text" 
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.FundingSource}
                            name="FundingSource"
                        />
                    }
                </div>
            }
            {
                formik.values.Funding > 0 && 
                <div className="form-group">
                    <label htmlFor="" className="label">Funding Institution</label>
                    <div className="description">Intitution that funded this research</div>
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <input type="text" className="form-control text" 
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.FundingInst}
                            name="FundingInst"
                        />
                    }
                </div>
            }          
            <hr />
            <div className="text-right">
                <button type="submit" className='btn btn-orange'>Complete</button>
            </div>
        </form>
    )
}

export default connect(StateMape)(EditResearch);